import { useQuery } from '@apollo/client';
import {
  ULTRA_PLAN_SUBSCRIBER_CHILD_PROFILES,
  ULTRA_PLAN_SUBSCRIPTION_ADMIN,
} from '../graphql/Queries';
import { getActiveDefaultChild } from '../ultraPlanUtils';

const useUltraPlanSubscriber = ({ userId, userSubscriptionId }) => {
  const {
    data: subscriptionData,
    loading: isSubscriptionLoading,
    refetch: refetchSubscription,
  } = useQuery(ULTRA_PLAN_SUBSCRIPTION_ADMIN, {
    variables: { where: { id: userId } },
    skip: !userId,
    fetchPolicy: 'cache-first',
    onError() {},
  });

  const {
    data: childProfilesData,
    loading: isChildProfilesLoading,
    error: childProfilesError,
    refetch: refetchChildProfiles,
  } = useQuery(ULTRA_PLAN_SUBSCRIBER_CHILD_PROFILES, {
    variables: { data: { userSubscriptionId } },
    skip: !userSubscriptionId,
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    onError() {},
  });

  const subscription = subscriptionData?.userSubscriptionAdmin?.data || null;
  const childProfiles =
    childProfilesData?.ultraPlanSubscriberChildProfiles?.data || [];

  return {
    subscription,
    isSubscriptionLoading: isSubscriptionLoading && !subscriptionData,
    refetchSubscription,
    childProfiles,
    isChildProfilesLoading: isChildProfilesLoading && !childProfilesData,
    hasChildProfilesError: !!childProfilesError && !childProfilesData,
    refetchChildProfiles,
    defaultChild: getActiveDefaultChild(childProfiles),
    isSubscriptionMismatch:
      !!subscription?.id && subscription?.id !== userSubscriptionId,
  };
};

export default useUltraPlanSubscriber;
